import {action, observable} from 'mobx';
import {databaseRef, firebaseStorage} from '../../helperFunctions/firebaseStore';
import {ICategory, IItem, IMenuStore} from "../storeInterfaces/menuStoreInterface";
import {convertObjToArray} from "./ordersStore";
import {IBrand} from "../storeInterfaces/brandsStoreInterface";

export const convertDataURLToFile = (url: string): Promise<File> => fetch(url)
    .then(res => res.blob())
    .then(blob => {
        return new File([blob], "File name", {type: 'image'});
    });

export class MenuStore implements IMenuStore {

    @observable
    categories: ICategory[] = [];
    @observable
    items: IItem[] = [];
    @observable
    brands: IBrand[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    mapCategoriesItemsBrands = async () => {
        this.failed = false;
        this.loaded = false;
        try {
            await databaseRef.ref('/categories/').on('value', snapshot => {
                this.categories = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
            await databaseRef.ref('/items/').on('value', snapshot => {
                this.items = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
            await databaseRef.ref('/brands/').on('value', snapshot => {
                this.brands = snapshot ? convertObjToArray(snapshot.val()) : [];
            });
        } catch (e) {
            this.failed = true;
        } finally {
            this.loaded = true;
        }
    };

    @action
    editItem = async (itemId: string, dataToEdit: IItem) => {
        try {
            const processImages = () => Promise.all(dataToEdit.images.map((image: any,index: number) => {
                return new Promise(async resolve => {
                    const e = await firebaseStorage.ref(`itemsLogos/${itemId}/${index}/`).put(image);
                    const img = await e.ref.getDownloadURL();
                    resolve(img);
                });
            }));
            dataToEdit.images = await processImages();
            if (dataToEdit.image[0].name) {
                const e = await firebaseStorage.ref(`itemsLogos/${itemId}/`).put(dataToEdit.image[0]);
                dataToEdit.image = await e.ref.getDownloadURL();
            }
            if (dataToEdit.image[0].imageUrl) delete dataToEdit.image;
            const brand = this.brands.find((item: any) => {
                return item.brandId === dataToEdit.brandId;
            });
            dataToEdit.brandName = brand!.brandName;
            dataToEdit.updatedAt = Date.now();
            dataToEdit.discount = dataToEdit.discount ? dataToEdit.discount : 0;
            await databaseRef.ref('/items/' + itemId).update(dataToEdit);
        } catch (error) {
            console.log(error);
        }
    };

    @action
    addItem = async (itemToAdd: IItem) => {
        const brand = this.brands.find((item: any) => {
            return item.brandId === itemToAdd.brandId;
        });
        itemToAdd.brandName = brand!.brandName;
        const itemId = databaseRef.ref('/items/').push(itemToAdd).key;
        const e = await firebaseStorage.ref(`itemsLogos/${itemId}/`).put(itemToAdd.image[0]);
        itemToAdd.image = await e.ref.getDownloadURL();
        const processImages = () => Promise.all(itemToAdd.images.map((image: any,index: number) => {
            return new Promise(async resolve => {
                const e = await firebaseStorage.ref(`itemsLogos/${itemId}/${index}/`).put(image);
                const img = await e.ref.getDownloadURL();
                resolve(img);
            });
        }));
        itemToAdd.images = await processImages();
        itemToAdd.updatedAt = Date.now();
        itemToAdd.discount = itemToAdd.discount ? itemToAdd.discount : 0;
        return databaseRef.ref('/items/' + itemId).set({...itemToAdd, itemId});
    };

    @action
    deleteItem = async (itemId: string) => {
        await firebaseStorage.ref(`itemsLogos/${itemId}/`).delete();
        return databaseRef.ref('/items/' + itemId).remove();
    };

    @action
    getItemById = (itemId: string) => {
        return databaseRef.ref('/items/' + itemId).once('value');
    };
    @action
    editCategory = async (categoryId: string, dataToEdit: ICategory) => {
        try {
            if (dataToEdit.categoryImage[0].name) {
                const e = await firebaseStorage.ref(`categoriesLogos/${categoryId}/`).put(dataToEdit.categoryImage[0]);
                dataToEdit.categoryImage = await e.ref.getDownloadURL();
            }
            if (dataToEdit.categoryImage[0].imageUrl) delete dataToEdit.categoryImage;
            dataToEdit.updatedAt = Date.now();
            await databaseRef.ref('/categories/' + categoryId).update(dataToEdit);
        } catch (error) {
            console.log(error);
        }

        return databaseRef.ref('/categories/' + categoryId).update(dataToEdit);
    };

    @action
    addCategory = async (categoryToAdd: ICategory) => {
        const categoryId = databaseRef.ref('/categories/').push(categoryToAdd).key;
        const e = await firebaseStorage.ref(`categoriesLogos/${categoryId}/`).put(categoryToAdd.categoryImage[0]);
        categoryToAdd.categoryImage = await e.ref.getDownloadURL();
        categoryToAdd.updatedAt = Date.now();
        return databaseRef.ref('/categories/' + categoryId).set({...categoryToAdd, categoryId});
    };

    @action
    deleteCategory = async (categoryId: string) => {
        this.items.filter(item => item.categoryId === categoryId)
            .forEach(async item => {
                await firebaseStorage.ref(`itemsLogos/${item.itemId}/`).delete();
                await databaseRef.ref('/items/' + item.itemId).remove();
            });
        await firebaseStorage.ref(`categoriesLogos/${categoryId}/`).delete();
        return databaseRef.ref('/categories/' + categoryId).remove();
    };

    @action
    getCategoryById = (categoryId: string) => {
        return databaseRef.ref('/categories/' + categoryId).once('value');
    };
}